<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay>
    <v-card>
      <v-card-title class="mx-3">
        <span
          class="d-inline-block text-truncate"
        >
          {{ settlement.name }}
          {{
            currentItem ? $t("Material.materialNameWithCode", [
              currentItem.material_code,
              currentItem.material_name,
            ]) : ''
          }}
        </span>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false"
              >fa-times
            </v-icon>
          </template>
          <span>
            {{ $t("$vuetify.close") }}
          </span>
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-data-table
        :headers="headers"
        :items="materialDetails"
        :loading="loading"
        disable-sort
        class="elevation-2 px-4 mt-4 pb-4"
        disable-pagination
        hide-default-footer
      >
        <template v-slot:item.standard_name="{ item }">
          <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
            {{ item.standard_name.slice(0, 12) + "......" }}
          </span>
          <span v-else>
            {{ item.standard_name }}
          </span>
        </template>
        <template v-slot:item.price="{ item }">
          {{ $t("Global.money") }}{{ item.price | formatMoneyFloor(true) }}
        </template>
        <template v-slot:item.total="{ item }">
          {{ $t("Global.money") }}{{ item.total | formatMoneyFloor(true) }}
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import Settlements from "@/api/settlements";
import i18n from "@/i18n";
import dialogBackInterceptor from "@/plugins/dialogBackInterceptor";

export default {
  name: "SettlementMaterialDialog",
  mixins: [dialogBackInterceptor],

  props: {
    value: Boolean,
    currentItem: Object,
    type: Number,
  },

  computed: {
    headers() {
      let headers = [];
      headers.push(
        {
          text: i18n.t("ShopMaterialView.Fields.org_code"),
          align: "start",
          value: "org_code",
        },
        {
          text: i18n.t("ShopMaterialView.Fields.org_created"),
          align: "start",
          value: "org_created",
        },
        {
          text: i18n.t("ShopMaterialView.Fields.category_name"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("ShopMaterialView.Fields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("ShopMaterialView.Fields.material_name"),
          align: "start",
          value: "material_name",
        },
      )
      if (this.type == 1) {
        headers.push(
          {
            text: i18n.t("ShopMaterialView.Fields.order_num"),
            align: "start",
            value: "order_num",
          },
          {
            text: i18n.t("ShopMaterialView.Fields.distribution_num"),
            align: "start",
            value: "distribution_num",
          },
          {
            text: i18n.t("ShopMaterialView.Fields.examine_num"),
            align: "start",
            value: "examine_num",
          },
        )
      }
      if (this.type == 2) {
        headers.push(
          {
            text: i18n.t("PurchaseMaterialView.Fields.order_num"),
            align: "start",
            value: "order_num",
          },
        )
      }
      if (this.type == 3) {
        headers.push(
          {
            text: i18n.t("RequisitionMaterialView.Fields.order_num"),
            align: "start",
            value: "order_num",
          }
        )
      }
      headers.push(
        {
          text: i18n.t("ShopMaterialView.Fields.stock_num"),
          align: "start",
          value: "stock_num",
        },
        {
          text: i18n.t("ShopMaterialView.Fields.finance_bill_num"),
          align: "start",
          value: "finance_bill_num",
        },
        {
          text: i18n.t("ShopMaterialView.Fields.bill_num"),
          align: "start",
          value: "bill_num",
        },
        {
          text: i18n.t("ShopMaterialView.Fields.unit"),
          align: "start",
          value: "unit",
        },
        {
          text: i18n.t("ShopMaterialView.Fields.standard_name"),
          align: "start",
          value: "standard_name",
        },
        {
          text: i18n.t("ShopMaterialView.Fields.price"),
          align: "start",
          value: "price",
        },
        {
          text: i18n.t("ShopMaterialView.Fields.total"),
          align: "start",
          value: "total",
        },
      )
      return headers;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    dialog: false,
    settlement: {},
    materialDetails: [],
  }),

  watch: {
    dialog: {
      handler() {
        this.$emit("input", null);
      },
    },
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.settlement = {};
        this.materialDetails = []
        if (this.value && this.currentItem) {
          this.dialog = true;
          Settlements.getDetailByMaterial(this.currentItem.settlement_id, { material_id: this.currentItem.material_id, standard_detail_id: this.currentItem.standard_detail_id}).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.settlement = response.data.settlement;
                this.materialDetails = this.settlement.material_details
              }
            }.bind(this)
          )
        }else {
          this.settlement = {};
          this.materialDetails = [];
        }
      },
    },
  },
};
</script>